// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"492":"3b79d103","757":"3b79d103"}[chunkId] + ".chunk.css";
};